import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";

import Regional from "../../assets/navbar/Regional_on.svg";
import PessoaJuridica from "../../assets/navbar/Pessoa_juridica_on.svg";
import Usuario from "../../assets/navbar/Usuario_on.svg";
import Convenios from "../../assets/navbar/Convenios_on.svg";
import Agentes from "../../assets/navbar/Agentes_on.svg";

import Button from "../../components/Button";

import api from "../../services/api";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import { toast } from "react-toastify";

import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import SkeletonListItem from "../SkeletonListItem";
import InputText from "../InputText";
import InputSearch from "../InputSearch";

import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";
import BorderForSort from "../BorderForSort";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";
import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../Button-v2";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListAgent({
  history,
  pageFilter,
  filter,
  state,
  stateName,
  type,
}) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);

  const [agents, setAgents] = useState([]);
  const [search, setSearch] = useState("");
  const [searchStateName, setSearchStateName] = useState("");
  const [searchState, setSearchState] = useState("");
  const [searchType, setSearchType] = useState("AGENTE");
  const [loading, setLoading] = useState(0);

  const [orderDirection, setorderDirection] = useState("ASC");
  const [orderByColumn, setorderByColumn] = useState("nome_agente");
  const [sortIndex, setSortIndex] = useState(0);

  async function getDataByAgentCnpj(cpfCnpj, state, type, page) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `api/agente/buscar?${type !== "" ? `type=${type}` : ""}${
          cpfCnpj !== "" ? `&cnpjOuNome=${cpfCnpj}` : ""
        }${state !== "" ? `&uf=${state}` : ""}&page=${
          page || 0
        }&size=${pageLimit}&sort=${orderByColumn},${orderDirection}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setAgents(response.data.content);
        setPage(page || 0);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setPage(page || 0);
        setAgents([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar os agentes.");
      }

      setIsLoading(false);
    } catch (err) {
      setPage(page || 0);
      setTotalPages(0);
      setTotalElements(0);
      setAgents([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar os agentes.");
      }
    }
  }

  useEffect(() => {
    if (filter) {
      setSearch(filter);
    }
    if (state) {
      setSearchState(state);
      setSearchStateName(stateName);
    }
    if (type) {
      setSearchType(type);
    }

    if (pageFilter) {
      setPage(pageFilter);
    }

    loadAgent(filter, state, type, pageFilter);
  }, [filter, state, type, pageFilter, pageLimit, sortIndex]);

  async function loadAgent(filter, state, type, page) {
    getDataByAgentCnpj(filter, state, type, page);
  }

  const reloadPage = (filter, page) => {
    history.replace(
      `?filter=${desmaskIfNumber(filter.search)}${
        filter.searchType !== "" ? `&type=${filter.searchType}` : ""
      }${
        filter.searchState !== ""
          ? `&uf=${filter.searchState}&ufName=${filter.searchStateName}`
          : ""
      }${page && page > 0 ? "&page=" + page : ""}`
    );
  };

  const selectNumberRegistry = async (item) => {
    setPageLimit(item.id);
  };

  const handleKeyPress = (event) => {
    const value = event.target.value;
    if (event.key === "Enter") {
      reloadPage({
        search,
        searchState,
        searchStateName,
        searchType,
      });
    }
  };

  const verifyIfIsEnabled = (pessoaJuridica, entity, image, url) => {
    if (!pessoaJuridica || pessoaJuridica === null) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (
      pessoaJuridica &&
      (!pessoaJuridica?.tipoEntityPessoa ||
        pessoaJuridica?.tipoEntityPessoa === null)
    ) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (pessoaJuridica && pessoaJuridica?.tipoEntityPessoa) {
      let pessoaJuridicaSearched = pessoaJuridica?.tipoEntityPessoa.find(
        (x) => x.papelPessoaJuridica === entity
      );
      if (pessoaJuridicaSearched && pessoaJuridicaSearched !== null) {
        return (
          <S.SvgIcon
            onClick={() => {
              history.push(`/${url}`);
            }}
            src={image}
            alt=""
          />
        );
      }
    }

    return <S.SvgIconDisabled src={image} alt="" />;
  };

  const selectSort = async (item) => {
    setSortIndex(item.id);

    switch (item.sort) {
      case "DESC":
        setorderByColumn("nome_agente");
        setorderDirection("DESC");
        break;
      case "ASC":
        setorderByColumn("nome_agente");
        setorderDirection("ASC");
        break;
      case "DataDESC":
        setorderByColumn("data_registro");
        setorderDirection("DESC");
        break;
      case "DataASC":
        setorderByColumn("data_registro");
        setorderDirection("ASC");
        break;
    }
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <S.SearchWrapper>
            <div className="labelFilter">Filtrar pesquisa</div>
            <div className="boxSearch">
              <S.InputRadioBox>
                <S.InputRadio>
                  <label>
                    <>
                      <input
                        type="radio"
                        name="searchType"
                        className="radio"
                        value={searchType}
                        checked={searchType === "AGENTE"}
                        onChange={() => setSearchType("AGENTE")}
                      />
                      Agente{" "}
                    </>
                  </label>
                  <label>
                    <>
                      <input
                        type="radio"
                        name="searchType"
                        className="radio"
                        value={searchType}
                        checked={searchType === "REGIONAL"}
                        onChange={() => setSearchType("REGIONAL")}
                      />
                      Regional{" "}
                    </>
                  </label>
                </S.InputRadio>
              </S.InputRadioBox>
              <div className="wrapperInputButton">
                <div className="inputContainer">
                  <span className="inputWrapper">
                    <InputText
                      type="text"
                      name="search"
                      label="CPF, CNPJ ou Nome:"
                      alwaysShowMask={false}
                      autoComplete={"off"}
                      value={search}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onChange={(ev) => setSearch(ev.target.value)}
                    />
                  </span>
                  <span className="inputWrapper">
                    <InputSearch
                      name="searchEstado"
                      label="Estado:"
                      type="ESTADO"
                      alwaysShowMask={false}
                      autoComplete={"off"}
                      initialValue={searchStateName}
                      onKeyPress={(e) => handleKeyPress(e)}
                      handleSearch={(ev) => {
                        setSearchStateName(ev?.nome || "");
                        setSearchState(ev?.uf || "");
                      }}
                    />
                  </span>
                </div>
                <Button
                  type="button"
                  onClick={() =>
                    reloadPage({
                      search,
                      searchState,
                      searchStateName,
                      searchType,
                    })
                  }
                >
                  consultar
                </Button>
              </div>
            </div>
          </S.SearchWrapper>
          <S.CardHeader>
            <span>
              {`${totalElements} agente${
                totalElements > 1 ? "s" : ""
              } cadastrado${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
            {totalElements > 0 && (
              <span className="border">
                Selecione o icone para acessar o cadastro
              </span>
            )}
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {agents &&
                agents?.map((user) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() =>
                            history?.push(
                              `/cadastro-agentes/${user?.pessoa?.id}`
                            )
                          }
                        >
                          <S.SvgIcon src={Agentes} alt="" />
                          <div className="dataCard">
                            <h4>CNPJ:</h4>
                            <h4>Nome:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {mask(
                                user?.pessoa?.cpfCnpj,
                                user?.pessoa?.cpfCnpj.length > 11
                                  ? "##.###.###/####-##"
                                  : "###.###.###-##",
                                true
                              )}
                            </h4>
                            <h4 className="h4-info">
                              {user?.nomeAgente + " | " + user?.pessoa?.nome}
                            </h4>
                          </div>
                        </S.Info>

                        {user?.status ? (
                          <div className="iconService">
                            <Button
                              type="button"
                              onClick={() => {
                                history.push(
                                  `/cadastro-usuario?cnpj=${desmaskIfNumber(
                                    user?.pessoa?.cpfCnpj
                                  )}`
                                );
                              }}
                            >
                              <S.SvgIconInvert src={Usuario} alt="" />
                              Adicionar usuário
                            </Button>
                            <S.SvgIcon
                              onClick={() => {
                                if (!user?.pessoa || user?.pessoa === null) {
                                  toast.error(
                                    "Este agente não possui uma pessoa jurídica vinculada!"
                                  );
                                  return;
                                }

                                history.push(
                                  `/cadastro-pessoa-juridica/${user?.pessoa?.id}`
                                );
                              }}
                              src={PessoaJuridica}
                              alt=""
                            />
                            {verifyIfIsEnabled(
                              user?.regional?.pessoa,
                              "REGIONAL",
                              Regional,
                              `cadastro-regionais/${user?.regional?.pessoa?.id}`
                            )}
                            {verifyIfIsEnabled(
                              user?.convenio?.pessoa,
                              "CONVENIO",
                              Convenios,
                              `cadastro-convenios/${user?.convenio?.pessoa?.id}`
                            )}
                          </div>
                        ) : (
                          <div className="WrapperInativo">
                            <Button className="inativo">
                              Cadastro Inativo
                            </Button>
                          </div>
                        )}
                      </S.Custumer>
                    </>
                  );
                })}
              <div className="rodaPe">
                <div className="select1">
                  <S.SelectContainer>
                    <BorderForSelectNumberOfRecords
                      selected={0}
                      handleSearch={selectNumberRegistry}
                      initialValue={pageLimit}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  <S.SelectContainer>
                    <BorderForSort
                      selected={0}
                      handleSearch={selectSort}
                      initialValue={sortIndex}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  {totalPages > 1 && (
                    <TablePagination
                      component="div"
                      classes={{
                        toolbar: classes.toolbar,
                        caption: classes.caption,
                      }}
                      count={totalElements}
                      page={page}
                      labelDisplayedRows={({ from, to, count }) => {
                        return from + " - " + to + " de " + count;
                      }}
                      onPageChange={(p, newPage) => reloadPage(search, newPage)}
                      rowsPerPageOptions={[10]}
                      rowsPerPage={pageLimit}
                    />
                  )}
                </div>
              </div>
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Card>
      </S.Container>
    </>
  );
}
